import FormattedMessage from 'I18n/components/FormattedMessage';
import { COLLABORATION_GENERATE_ACTION } from 'automation-ui-canvas/constants/Gates';
import CollabGenActionsFlowContent from 'automation-ui-canvas/containers/flow-views/collab-gen-actions-flow/CollabGenActionsFlowContent';
import useGetCollabGenActionsFlowData from 'automation-ui-canvas/containers/flow-views/collab-gen-actions-flow/useGetCollabGenActionsFlowData';
import CollabGenActionsExitModal from 'automation-ui-canvas/containers/flow-views/collab-gen-actions-flow/CollabGenActionsExitModal';
import { COLLAB_GEN_ACTIONS_FLOW_VIEW } from 'automation-ui-canvas/containers/flow-views/flowViewIds';
import { jsx as _jsx } from "react/jsx-runtime";
const CollabGenActionsFlowViewConfig = {
  id: COLLAB_GEN_ACTIONS_FLOW_VIEW,
  getIsAvailable: ({
    getIsUngated
  }) => getIsUngated(COLLABORATION_GENERATE_ACTION),
  useGetViewData: useGetCollabGenActionsFlowData,
  modeIndicator: {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.collabGenActionsFlow.mode"
    }),
    use: 'preview',
    ConfirmModal: CollabGenActionsExitModal
  },
  menuBar: {
    MenuBarComponent: null
  },
  ContentComponent: CollabGenActionsFlowContent
};
export default CollabGenActionsFlowViewConfig;